import { get } from "../../../../common/utils/index.js";
import * as CommonType from "../../actiontype/CommonType/CommonType.jsx";
import axios from 'axios';



export const onCommonReducerUpdate = (payload, reducerType) => {
    return ({ type: reducerType, payload })
  }

  export const onCommonReducerPatientData = (payload, reducerType) => {
    return ({ type: reducerType, payload })
  }

export const onCommonReducerResetPswd = (payload, reducerType) => {
    return ({ type: reducerType, payload })
  }


  export const getTranslate = () => (dispatch) => {
    
    dispatch({ type: CommonType.TRANSLATE_REQUEST })
    get(`/Master/Labels`)
    .then(res => {
        dispatch({ type: CommonType.TRANSLATE_SUCCESS, payload: res.data })
      })
      .catch(err => {
        dispatch({ type: CommonType.TRANSLATE_FAILURE, payload: err?.message })
      })
  }

export const getAuthenticationType = (showLoader,hideLoader,showToast) => (dispatch) => {
    showLoader();
    dispatch({ type: CommonType.AUTHENTICATION_TYPE_REQUEST })
    get(`/AuthenticationTypes`)
  
      .then(res => {
        hideLoader();
        dispatch({ type: CommonType.AUTHENTICATION_TYPE_SUCCESS, payload: res.data })
      })
      .catch(err => {
        hideLoader();
        dispatch({ type: CommonType.AUTHENTICATION_TYPE_FAILURE, payload: err?.message })
        // showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
      })
  }


const fetchTranslations = async () => {
  // https://devqtm.quicare.com:5001 http://192.168.1.116:5001
  try { 
    
    const response = await axios.get('https://devqtm.quicare.com:5001/api/Master/Labels');
    return response.data; 
  } catch (error) {
    console.error('Error fetching translations:', error);

    return null;
  }
};

export default fetchTranslations;
